import React, { useEffect } from "react";
import "./AccountTab.scss";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { AccountViewModel } from "@/features/settings/viewmodel/AccountViewModel";
import { UserBasicInfo } from "@features/settings/service/userService";

interface AccountTabProps {
  basicInfo?: UserBasicInfo | null;
  loading?: boolean;
}

export const AccountTab: React.FC<AccountTabProps> = () => {
  const {
    loading,
    formData,
    sessions,
    deleteModalOpen,
    deleteLoading,
    setDeleteModalOpen,
    handleInputChange,
    signOutSession,
    handleSaveNewEmail,
    handleSaveNewPass,
    handleDeleteAccount,
    handleCancel,
  } = AccountViewModel();

  // REMOVED - No longer needed since we're using Effector store
  // const userProfile = localStorage.getItem("userSettings") || "";
  // const userProfileObj = JSON.parse(userProfile);
  // console.log(userProfileObj, "obj");

  return (
    <div className="settings-account">
      {/* Email Section */}
      <Card className="account-card">
        <div className="card-section">
          <div className="section-header">
            <div>
              <h3 className="section-title">Email</h3>
              <p className="section-description">Update your email</p>
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="emailAddress" className="field-label">
              Email
            </label>
            <div className="field-input">
              <InputText
                id="emailAddress"
                className="w-full"
                value={formData.emailAddress || ""}
                onChange={(e) =>
                  handleInputChange("emailAddress", e.target.value)
                }
                placeholder="Email"
              />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="emailAddress" className="field-label">
              Current Password
            </label>
            <div className="field-input">
              <InputText
                id="oldPassword"
                type="password"
                className="w-full"
                value={formData.currentPassword}
                onChange={(e) =>
                  handleInputChange("currentPassword", e.target.value)
                }
                placeholder="••••••••"
              />
            </div>
          </div>

          <div className="form-actions">
            <Button
              className="button-cta"
              label="Cancel"
              severity="secondary"
              outlined
            />
            <Button
              onClick={() => {
                handleSaveNewEmail();
              }}
              className="button-cta-update"
              label="Update email"
            />
          </div>
        </div>
      </Card>

      {/* Password Section */}
      <Card className="account-card">
        <div className="card-section">
          <div className="section-header">
            <div>
              <h3 className="section-title">Password</h3>
              <p className="section-description">
                Please enter your current password to change your password.
              </p>
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="currentPassword" className="field-label">
              Current password
            </label>
            <div className="field-input">
              <InputText
                id="currentPassword"
                type="password"
                className="w-full"
                value={formData.currentPassword}
                onChange={(e) =>
                  handleInputChange("currentPassword", e.target.value)
                }
                placeholder="••••••••"
              />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="newPassword" className="field-label">
              New password
            </label>
            <div className="field-input">
              <InputText
                id="newPassword"
                type="password"
                className="w-full"
                value={formData.newPassword}
                onChange={(e) =>
                  handleInputChange("newPassword", e.target.value)
                }
                placeholder="••••••••"
              />
              <p className="field-hint">
                Your new password must be more than 8 characters.
              </p>
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="confirmPassword" className="field-label">
              Confirm new password
            </label>
            <div className="field-input">
              <InputText
                id="confirmPassword"
                type="password"
                className="w-full"
                value={formData.confirmPassword}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                placeholder="••••••••"
              />
            </div>
          </div>

          <div className="form-actions">
            <Button
              className="button-cta"
              label="Cancel"
              severity="secondary"
              outlined
            />
            <Button
              className="button-cta-update-pass"
              label="Update password"
              onClick={() => handleSaveNewPass()}
            />
          </div>
        </div>
      </Card>

      {/* Delete Account Section */}
      <Card className="account-card danger-card">
        <div className="card-section">
          <div className="section-header">
            <div>
              <h3 className="section-title">Delete account</h3>
              <p className="section-description">
                If you delete your account you'll lose all your activity and
                will not be able to recover it in the future.
              </p>
            </div>
            <Button
              className="button-cta-delete"
              label="Delete account"
              severity="danger"
              outlined
              onClick={() => setDeleteModalOpen(true)}
            />
          </div>
        </div>
      </Card>

      {/* Delete Confirmation Modal */}
      <Dialog
        visible={deleteModalOpen}
        onHide={() => setDeleteModalOpen(false)}
        header={null}
        closable={true}
        draggable={false}
        resizable={false}
        className="delete-account-dialog"
        style={{ width: "450px" }}
      >
        <div className="delete-modal-content">
          <div className="delete-modal-icon">
            <i
              className="pi pi-exclamation-circle"
              style={{ fontSize: "2rem", color: "#ef4444" }}
            ></i>
          </div>
          <h3 className="delete-modal-title">
            Are you sure you want to delete your account?
          </h3>
          <p className="delete-modal-description">
            All your data will be lost, including your personal details, your
            organisation and any other interaction on this platform
          </p>
          <div className="delete-modal-actions">
            <Button
              label="Cancel"
              className="p-button-outlined"
              onClick={() => setDeleteModalOpen(false)}
              disabled={deleteLoading}
            />
            <Button
              label="Delete account"
              severity="danger"
              onClick={handleDeleteAccount}
              loading={deleteLoading}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};
